import badgeImage from "../../images/badge.svg";

import bottleImage from "../../images/bottle.svg";

import canImage from "../../images/can.svg";

import kegImage from "../../images/keg.svg";

import snackImage from "../../images/snack.svg";

export const getItemImage = (containerType: string) => {
  const lowerCaseType = containerType.toLowerCase();
  if (lowerCaseType === "keg") return kegImage;
  else if (lowerCaseType === "cask") return kegImage;
  else if (lowerCaseType === "badge") return badgeImage;
  else if (lowerCaseType === "can") return canImage;
  else if (lowerCaseType === "bottle") return bottleImage;
  else if (lowerCaseType === "snack") return snackImage;
};
